import { createFileRoute } from '@tanstack/react-router'
import { StudentForm } from '@/features/students/components/student-form'

export const Route = createFileRoute('/_authenticated/students/create')({
  component: CreateStudent,
})

function CreateStudent() {
  return (
      <div className="p-4">
        <h1 className="text-2xl font-bold mb-4">Create Student</h1>
        <StudentForm student={null} />
      </div>
    )
}
